import React, { FC } from "react";
import styles from "./final-form-create-study.module.scss";
import checkGreenIcon from "../../../../images/approve.svg";
import checkGrayIcon from "../../../../images/approve-gray.svg";
import connectionIcon from "../../../../images/connection.svg";
import Tooltip from "../../../ui-kit/tooltip/tooltip";
import { useAppSelector } from "../../../../hooks/useAppSelector";

export type StatusType = "available" | "empty" | "lost";

const statusIconMap: Record<StatusType, string> = {
  available: checkGreenIcon,
  empty: checkGrayIcon,
  lost: connectionIcon,
};

const StatusIcon: FC<{ status: StatusType }> = ({ status }) => (
  <span className={styles.status}>
    <img
      src={statusIconMap[status]}
      alt={status}
      className={styles.iconImage}
    />
    {status === "available" && "Available"}
    {status === "empty" && "Empty"}
    {status === "lost" && "Lost connection"}
  </span>
);

const FinalFormCreateStudy = () => {
  const {
    bufferInfrastructureResults,
    externalServicesAvailability,
    mainForm,
  } = useAppSelector((state) => state.studyCreation);

  const hasAnyNetwork = Object.values(bufferInfrastructureResults).some(
    ({ available }) => available,
  );

  const externalServices = [
    { name: "GDB", status: hasAnyNetwork ? "available" : "empty" },
    {
      name: "NCSI",
      status: externalServicesAvailability.ncsi ? "available" : "lost",
    },
    {
      name: "OPIS",
      status: externalServicesAvailability.opis ? "available" : "lost",
    },
  ] as const;

  return (
    <div>
      <div className={styles.grid}>
        <span className={styles.label}>Name of the New Industrial City:</span>
        <p className={styles.value}>{mainForm.name}</p>

        <div className={styles.label}>External Services:</div>
        <div className={styles.value}>
          <div className={styles.services}>
            {externalServices.map((service) => {
              const disabled = service.status == "lost";
              return (
                <Tooltip
                  key={service.name}
                  classes={{ text: styles.tooltipText }}
                  disabled={!disabled}
                  text="Data not fetched: Check service connectivity or retry"
                >
                  <div
                    className={`${styles.serviceButton} ${disabled ? styles.disabled : ""}`}
                  >
                    <img
                      src={statusIconMap[service.status]}
                      alt={service.status}
                      className={styles.iconImage}
                    />
                    {service.name}
                  </div>
                </Tooltip>
              );
            })}
          </div>
        </div>
      </div>
      <div className={styles.analyticalReports}>
        <span className={styles.label}>Analytical reports:</span>
        <p>
          The system will automatically fetch analytical data from the selected
          services. Any missing data will appear as “Empty” or “Lost connection”
        </p>
        <div className={styles.reports}>
          {Object.values(bufferInfrastructureResults).map(
            ({ label, available }) => (
              <React.Fragment key={label}>
                <div className={styles.label}>{label}</div>
                <StatusIcon status={available ? "available" : "empty"} />
              </React.Fragment>
            ),
          )}
        </div>
      </div>
    </div>
  );
};

export default FinalFormCreateStudy;
